const typo = {
  fontFamily: 'Inter',
  fontSize: '14px',
  lineHeight: '146%',
  color: '#23252F;',
};

export const styles = {
  container: {},
  label: {
    ...typo,
    marginBottom: '8px',
  },
  textfield: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      ...typo,
      borderRadius: '12px',
      maxHeight: '48px',
      padding: '13px 14px',
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #EDEFF7 !important',
      },
      '& fieldset': {
        border: 0,
      },
      '& input': {
        paddingLeft: 0,
      },
    },
  },
  popper: {
    '& .MuiPickersPopper-paper': {
      borderRadius: '16px',
      boxShadow: 'none',
      border: '1px solid #EDEFF7',
      marginTop: '8px',
      marginRight: '8px',
    },
    '& .MuiPickersLayout-root': {
      '& .MuiList-root': {
        padding: '0',
        paddingTop: '4px',
        paddingRight: '4px',
        '& .MuiListItem-root': {
          padding: '0 16px',
        },
        '& .MuiButtonBase-root': {
          ...typo,
          fontWeight: 500,
          background: '#fff',
          height: '40px',
          '& .MuiChipLabel-root': {
            padding: 0,
          },
        },
        '& .Mui-disabled': {
          color: '#6E707A',
          paddingTop: '16px',
          paddingBottom: '8px',
        },
      },
    },
    '& .MuiPickersLayout-contentWrapper': {
      gridColumn: '1 !important',
      borderRight: '1px solid #EDEFF7',
      paddingTop: '4px',
      paddingLeft: '4px',
      '& .MuiPickersArrowSwitcher-button': {
        padding: 0,
      },
      '& .MuiTypography-root': {
        ...typo,
        fontWeight: 500,
      },
      '& .MuiDateRangePickerDay-root .MuiButtonBase-root': {
        ...typo,
        '&:hover': {
          border: '0',
        },
        '&.MuiPickersDay-today': {
          border: '1px solid #4D6EF5',
        },
        '&.Mui-selected': {
          backgroundColor: '#4D6EF5',
        },
      },
      '& .MuiDateRangePickerDay-rangeIntervalDayHighlight': {
        backgroundColor: '#4d6ef51f ',
        '&.MuiDateRangePickerDay-outsideCurrentMonth': {
          background: 'transparent',
        },
      },
    },
    '& .MuiDateRangeCalendar-monthContainer': {
      borderRight: '0 !important',
      '& .rotated': {
        transform: 'rotate(180deg)',
      },
    },
    '& .MuiDayCalendar-slideTransition': {
      minWidth: '300px',
    },
    '& .MuiPickersLayout-shortcuts': {
      gridColumn: '2 !important',
    },
    '& .MuiDialogActions-root': {
      padding: '16px',
      borderTop: '1px solid #EDEFF7',
      gridRow: '3',
      gridColumn: '1/3',
      '& .MuiButtonBase-root': {
        ...typo,
        textTransform: 'capitalize',
        padding: '6px 12px',
        color: '#4D6EF5',
        border: '1px solid #4D6EF5',
        borderRadius: '8px',
        '&.filled': {
          backgroundColor: '#4D6EF5',
          color: '#fff',
        },
      },
    },
  },
};
